module.exports = __webpack_public_path__ + "img/pin.f7ed1bb6.svg";